import type { ClientFolderId } from 'owa-client-ids';
import {
    getCalendarEntryByCalendarId,
    getCalendarFolderId,
    getCalendarIdByFolderId,
    getDefaultCalendar,
    isWritableCalendar,
} from 'owa-calendar-cache';
import { CalendarEntry } from 'owa-graph-schema';

export function getCalendarFolderIdForCompose(
    selectedCalendarIds?: string[]
): ClientFolderId | null {
    const writableCalendars = getWritableCalendars(selectedCalendarIds);
    const numWritableCalendars = writableCalendars ? writableCalendars.length : 0;

    let calendarForCompose: CalendarEntry | null = null;
    if (writableCalendars && numWritableCalendars > 0) {
        // default to the last calendar, since it was most recently selected
        calendarForCompose = writableCalendars[numWritableCalendars - 1];

        // prefer default calendar over other selected calendars
        const defaultCalendar = getDefaultCalendar();
        if (defaultCalendar) {
            writableCalendars.forEach(calendar => {
                if (calendar.calendarId.id == defaultCalendar.calendarId.id) {
                    calendarForCompose = defaultCalendar;
                }
            });
        }

        return {
            Id: getCalendarFolderId(calendarForCompose),
            mailboxInfo: calendarForCompose.calendarId.mailboxInfo,
        };
    }

    return null;
}

export function getCalendarFolderIdForComposeFromFolderIds(
    selectedFolderIds?: string[]
): ClientFolderId | null {
    const selectedCalendarIds: string[] = [];
    selectedFolderIds?.forEach(folderId => {
        const calendarId = getCalendarIdByFolderId(folderId);
        if (calendarId) {
            selectedCalendarIds.push(calendarId.id);
        }
    });
    return getCalendarFolderIdForCompose(selectedCalendarIds);
}

function getWritableCalendars(selectedCalendarIds?: string[]): CalendarEntry[] {
    const selectedCalendars: CalendarEntry[] = [];
    selectedCalendarIds?.forEach(calendarId => {
        const calendar = getCalendarEntryByCalendarId(calendarId);
        if (calendar) {
            selectedCalendars.push(calendar);
        }
    });
    return selectedCalendars.filter(isWritableCalendar);
}
